'use strict';

angular.module('webAgro1App').factory('OcorrenciaMaquinaObjectService', function($filter, filterFilter, OperacoesDadosService) {
  return {
    convertToSend: function(ocorrencia) {
      return {
        cd_propriedade: (ocorrencia.propriedade && ocorrencia.propriedade.id > 0) ? ocorrencia.propriedade.id : null,
        cd_maquina: (ocorrencia.maquina && ocorrencia.maquina.id > 0) ? ocorrencia.maquina.id : null,
        cd_safra: ocorrencia.safra.id,
        cd_operador: (ocorrencia.operador && ocorrencia.operador.id > 0) ? ocorrencia.operador.id : null,
        created_at: $filter('date')(new Date(), DATE_HOUR_ENGLISH_FORMAT),
        data: $filter('date')(ocorrencia.data, DATE_FORMAT),
        hora: $filter('date')(ocorrencia.hora, HOUR_FORMAT),
        data_prazo: $filter('date')(ocorrencia.dataPrazo, DATE_FORMAT),
        data_retorno: $filter('date')(ocorrencia.dataFechado, DATE_FORMAT),
        hora_retorno: $filter('date')(ocorrencia.horaFechado, HOUR_FORMAT),
        id: ocorrencia.id || null,
        item_ids: (ocorrencia.itensManutencao || []).map(function(item) {
          return item.id;
        }),
        hodometro: parseInt(ocorrencia.hodometro) || null,
        st_maquina_parada: ocorrencia.maquinaParada,
        relato: ocorrencia.relato,
        status: (ocorrencia.status || {}).id || null,
        st_tipo: ocorrencia.tipo ? ocorrencia.tipo.id : null
      };
    },

    convertToObject: function(ocorrencia) {
      var temOcorrencia = ocorrencia && ocorrencia.id;
      var comentarios = ocorrencia.comentarios.map(function(comentario) {
        comentario.imagens = OperacoesDadosService.getImagesObject(comentario.imagens, true);
        return comentario;
      });
      var result = !temOcorrencia ? {} : {
        id: ocorrencia.id,
        createdAt: moment(ocorrencia.created_at).toDate(),
        data: moment(ocorrencia.data).toDate(),
        dataPrazo: ocorrencia.data_prazo ? moment(ocorrencia.data_prazo).toDate() : null,
        dataFechado: ocorrencia.data_retorno ? moment(ocorrencia.data_retorno).toDate() : null,
        dataPrazoChecagem: ocorrencia.data_prazo_checagem ? moment(ocorrencia.data_prazo_checagem).toDate() : null,
        dataChecagem: ocorrencia.data_checagem ? moment(ocorrencia.data_checagem).toDate() : null,
        dataFechamento: ocorrencia.data_fechamento ? moment(ocorrencia.data_fechamento).toDate() : null,
        hora: ocorrencia.hora ? moment(new Date(ocorrencia.data + ' ' + ocorrencia.hora)).toDate() : null,
        horaFechado: ocorrencia.hora_retorno ? moment(new Date(ocorrencia.data_retorno +' '+ocorrencia.hora_retorno)).toDate() : null,
        imagens: OperacoesDadosService.getImagesObject([ocorrencia.imagem_horimetro], true).concat(OperacoesDadosService.getImagesObject(ocorrencia.imagens, true)),
        itensManutencao: ocorrencia.itens,
        localizacao: ocorrencia.localizacao,
        maquina: ocorrencia.maquina,
        operador: ocorrencia.operador,
        maquinaParada: ocorrencia.st_maquina_parada,
        negligencia: ocorrencia.imprudencia,
        relato: ocorrencia.relato,
        safra: ocorrencia.safra,
        hodometro: ocorrencia.hodometro ? parseInt(ocorrencia.hodometro) : null,
        status: TIPOS_STATUS_OCORRENCIA_MAQUINA[ocorrencia.status],
        tipo: filterFilter(TIPOS_OCORRENCIAS_MAQUINAS, {id: ocorrencia.st_tipo}, true)[0] || {},
        usuario: ocorrencia.usuario,
        usuarioFechamento: ocorrencia.usuario_fechamento,
        comentarios: comentarios
      };
      return result;
    }
  };
});
